export default __webpack_public_path__ + "static/media/image1.091935db.jpg";